import { useQuery } from '@tanstack/react-query';
import { adminApi, Role } from 'services/adminApi';

interface UseInvitableRolesResult {
  data: Role[] | null;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  refetch: () => void;
}

/**
 * Hook to fetch roles that can be invited as company admins
 * Returns Platform Manager and Company Admin roles
 */
export const useInvitableRoles = (
  options?: { enabled?: boolean }
): UseInvitableRolesResult => {
  const isEnabled = options?.enabled !== false;

  const query = useQuery({
    queryKey: ['roles', 'invitable-company-admins'],
    queryFn: async () => {
      const response = await adminApi.getInvitableRoles();
      return response.data;
    },
    enabled: isEnabled,
    staleTime: 1000 * 60 * 10, // 10 minutes - roles don't change often
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    gcTime: 1000 * 60 * 15, // 15 minutes
  });

  return {
    data: query.data || null,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};
